module.exports = "pegasus_template/assets/themelp1/simple/100.png";